<template>
  <div class="form-group">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="mb-0 font-weight-bold">
        {{ title }}:
        <span class="text-danger">*</span>
        <b-badge variant="secondary" class="ml-2">{{
          items.length
        }}</b-badge>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="$emit('add-item')"
      >
        <i class="fa fa-plus"></i> Añadir
      </button>
    </div>
    <div v-if="items.length === 0" class="text-muted mb-3">
      <small>{{ emptyMessage }}</small>
    </div>
    <div
      v-for="(item, index) in items"
      :key="`${fieldId}-${index}-${item.id || 'new'}`"
      class="mb-3 p-3 border rounded relation-item"
      :class="getBorderClass(item, index)"
    >
      <div class="d-flex justify-content-between align-items-start mb-2">
        <div class="mb-0 font-weight-bold">
          {{ itemLabel }} {{ index + 1 }}:
          <b-badge
            v-if="item.id === null"
            variant="success"
            class="ml-1"
            >Nuevo</b-badge
          >
        </div>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          @click="$emit('remove-item', index)"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>
      <input
        :value="item.name"
        @input="$emit('update-item', index, $event.target.value)"
        @blur="$emit('touch-field', index)"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': hasError(index) }"
        :id="`${fieldId}-${index}`"
        :placeholder="placeholder"
        maxlength="255"
      />
      <div v-if="hasError(index)" class="invalid-feedback">
        <div v-if="!isFieldValid(index, 'required')">{{ errorMessages.required }}</div>
        <div v-if="!isFieldValid(index, 'maxLength')">{{ errorMessages.maxLength(255) }}</div>
      </div>
      <small class="text-muted"
        >{{ item.name ? item.name.length : 0 }}/255 caracteres</small
      >
    </div>
  </div>
</template>

<script>
import { errorMessages } from "@/helpers/validations/errorMessages";

export default {
  name: "NameRelationTab",
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    fieldErrors: {
      type: Object,
      default: () => ({}),
    },
    emptyMessage: {
      type: String,
      required: true,
    },
    itemLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errorMessages,
    };
  },
  methods: {
    hasError(index) {
      return this.fieldErrors[index] && this.fieldErrors[index].hasError;
    },
    isFieldValid(index, rule) {
      if (!this.fieldErrors[index]) return true;
      return this.fieldErrors[index][rule] !== false;
    },
    getBorderClass(item, index) {
      const hasError = this.hasError(index);
      const hasContent = item.name && item.name.trim() !== '';
      
      if (hasError) {
        return 'border-danger';
      } else if (item.id === null && hasContent) {
        return 'border-success';
      } else if (item.id !== null && !hasError) {
        return 'border-primary';
      } else {
        return 'border-secondary';
      }
    },
  },
  emits: ["add-item", "remove-item", "update-item", "touch-field"],
};
</script>
